export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/;

// Only letters (a-z, A-Z) and special characters: space, hyphen, apostrophe, period
export const NAME_REGEX = /^[a-zA-Z\s\-'.]+$/;

export const PASSWORD_REQUIREMENTS = {
  minLength: "At least 8 characters",
  maxLength: "Maximum 16 characters",
  uppercase: "At least one uppercase letter (A-Z)",
  lowercase: "At least one lowercase letter (a-z)",
  number: "At least one number (0-9)",
  specialChar: "At least one special character (!@#$%^&*)",
  noSpaces: "No spaces allowed"
};

export const SortOrder = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

// Viewport below which the sidebar behaves as an off-canvas drawer.
// Keep in sync with the $sidebar-breakpoint value in styles/sidebar.scss.
export const MOBILE_BREAKPOINT_QUERY = "(max-width: 1023px)";

export const SORT_BY = {
  NAME: "name",
  DATE: "date",
  SCORE: "score",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
} as const;
